import React from 'react';
import Modal from '@blaze-react/modal';
import ReactDOM from 'react-dom';
import usePortal from '../utils/use-portal';

const PortalAdapter = ({ children }) => {
  const target = usePortal();

  return ReactDOM.createPortal(children, target);
};

export default PortalAdapter;
